const FACTION_TOWN_IMG_MAP = {
  castle: 'TPCASCAS',
  rampart: 'TPCASRAM',
  tower: 'TPCASTOW',
  necropolis: 'TPCASNEC',
  dungeon: 'TPCASDUN',
  stronghold: 'TPCASNEU',
  fortress: 'TPCASFOR',
  inferno: 'TPCASINF',
  conflux: 'TPCasEle',
  cove: 'CRBKGCOV',
}

const FACTION_TOWN_SPRITE_MAP = {
  castle: 'AVCCASX0',
  rampart: 'AVCRAMX0',
  tower: 'AVCTOWX0',
  necropolis: 'AVCNECX0',
  dungeon: 'AVCDUNX0',
  stronghold: 'AVCSTRX0',
  fortress: 'AVCFTRX0',
  inferno: 'AVCINFX0',
  conflux: 'AVCHFORX',
}

export default {
  // Castle = 1,  // 城堡
  // Rampart = 2, // 壁垒
  // Tower = 3, // 塔楼
  // Necropolis = 4, // 亡灵
  // Dungeon = 5, // 地下城
  // Stronghold = 6, // 据点
  // Fortress = 7, // 要塞
  // Inferno = 8, // 地狱
  // Conflux = 9, // 元素
  // Cove = 10, // 港口
  // Neutral = 100, // 中立

  INITIAL_FACTIONS: [
    'castle',
    'rampart',
    'tower',
    'necropolis',
    'dungeon',
    'stronghold',
    'fortress',
    'inferno',
  ],

  FACTIONS: [
    'castle',
    'rampart',
    'tower',
    'necropolis',
    'dungeon',
    'stronghold',
    'fortress',
    'inferno',
    'conflux',
    'cove',
    // 'neutral',
  ],

  FACTIONS_VALUE: {
    castle: 1,
    rampart: 2,
    tower: 3,
    necropolis: 4,
    dungeon: 5,
    stronghold: 6,
    fortress: 7,
    inferno: 8,
    conflux: 9,
    cove: 10,
    neutral: 100,
  },

  FACTIONS_VALUE_NAME: {
    1: 'castle',
    2: 'rampart',
    3: 'tower',
    4: 'necropolis',
    5: 'dungeon',
    6: 'stronghold',
    7: 'fortress',
    8: 'inferno',
    9: 'conflux',
    '10': 'cove',
    '100': 'neutral',
  },

  FACTION_ENG_CH: {
    necropolis: '墓园',
    castle: '城堡',
    rampart: '壁垒',
    tower: '塔楼',
    inferno: '地狱',
    dungeon: '地下城',
    stronghold: '据点',
    fortress: '要塞',
    conflux: '元素',
    cove: '港口',
    neutral: '中立',
  },

  FACTION_TOWN_IMG_MAP,

  FACTION_TOWN_SPRITE_MAP,

  getFactionTownSprite (faction) {
    return `${process.env.VUE_APP_OSS_URL}/img/common/town/${FACTION_TOWN_SPRITE_MAP[faction]}.png`
  },
}
